<template>
  <v-flex>
    <v-skeleton-loader
      :loading="loading"
      height="400"
      transition="scale-transition"
      type="image"
    >
      <apexchart
        :options="chartOptions"
        :series="series"
        height="auto"
        type="radar"
      />
    </v-skeleton-loader>
  </v-flex>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import DashService from "@/services/dashboard.service";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    modules: Array,
    title: String,
    subTitle: String,
    icon: String,
    cardColor: {
      type: String,
      default: "white",
    },
    iconColor: {
      type: String,
      default: "success",
    },
    courseId: Number,
    mockLogId: Number,
  },
  created() {
    let labels = this.prepareLabels();
    this.chartOptions.xaxis.categories = labels;
    this.chartOptions.labels = labels;
    this.series[0].data = this.modules.map((m) => m.score);
    this.loading = false;
  },
  data() {
    return {
      loading: true,
      chartOptions: {
        labels: null,
        title: {
          text: "",
        },
        plotOptions: {
          radar: {
            size: 100,
            polygons: {
              strokeColor: "#e9e9e9",
              fill: {
                colors: ["#fff", "#fff"],
              },
            },
            offsetX: 5,
            offsetY: 5,
          },
        },
        xaxis: {
          categories: [],
          labels: {
            show: true,
            rotate: 0,
            rotateAlways: false,
            hideOverlappingLabels: true,
            showDuplicates: false,
            trim: true,
            minHeight: 80,
            maxHeight: 10,
            style: {
              colors: [],
              fontSize: "10px",
              fontFamily: "Helvetica, Roboto, sans-serif",
              fontWeight: 400,
              cssClass: "apexcharts-xaxis-label",
            },
            offsetX: 5,
            offsetY: 5,
          },
        },
      },
      series: [
        {
          name: "Média (%)",
          data: null,
        },
      ],
      modulesName: {
        1: "Planejamento Financeiro",
        2: "Gestão de Ativos e Investimentos",
        3: "Planejamento de Aposentadoria",
        4: "Gestão de Riscos e Seguros",
        5: "Planejamento Fiscal",
        6: "Planejamento Sucessório",
      },
    };
  },
  computed: {},
  mounted() {
    console.log(this.series[0].data);
    console.log("categorias:");
    console.log(this.chartOptions.xaxis.categories);
    console.log("labels");
    console.log(this.chartOptions.labels);
  },
  methods: {
    prepareLabels() {
      return this.modules.map((m) => {
        return this.modulesName[m.module_number];
      });
    },
  },
};
</script>
